import { useApi } from './use-api-call';

export const useSearchContactUsApi = () =>
    useApi<{
        contactuses: ContactUsDTO[];
        allowEdit: boolean;
    }>('/contact-us/search-contact-us');

export const useGetContactUsApi = () =>
    useApi<{ contactUs: ContactUsDTO; allowEdit: boolean }>('/contact-us/get-contact-us/{id}');

export const useSaveContactUsApi = () =>
    useApi<{ contactUs: ContactUsDTO }>('/contact-us/save-contact-us');

export const useDeleteContactUsApi = () => useApi('/contact-us/delete-contact-us/{id}');

export interface ContactUsDTO {
    id?: number;
    username: string;
    phone: string;
    email: string;
    subject: string;
    message: string;
    createdAt?: Date;
    createdBy?: string;
}
